import Save from "assets/save.svg";
import { ReactNode } from "react";
import * as S from "./styles";

interface InputProps {
  id: string;
  buttonText: string;
  secondButtonText?: string;
  name: string;
  type: string;
  placeholder?: string;
  required: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  secondOnClick?: () => void;
  onClick: () => void;
  disabled?: boolean;
  onSaveClick?: () => void;
  haveExport?: boolean;
  Button?: ReactNode;
  isOccurrence?: boolean;
  secondButton?: boolean;
  variants?: "exportButton" | "disabledButton" | " ";
}

export function SearchBar({
  id,
  name,
  type,
  placeholder,
  required,
  onChange,
  buttonText,
  onClick,
  disabled = false,
  onSaveClick,
  haveExport,
  Button,
  isOccurrence = false,
  secondButton = false,
  secondButtonText,
  secondOnClick,
  variants,
}: InputProps) {
  return (
    <S.SearchBar>
      <S.Input
        id={id}
        name={name}
        type={type}
        data-for="searchTooltip"
        data-tip="Para pesquisar por tipo de ocorrencia 
        digite 1 para residencial e 2 para veicular"
        data-iscapture="true"
        placeholder={placeholder}
        required={required}
        onChange={onChange}
      />
      {haveExport && (
        <S.Button onClick={onSaveClick} variants={"exportButton"}>
          <img src={Save} alt="export-img" />
        </S.Button>
      )}
      {Button && Button}
      {!disabled && <span>|</span>}
      {!disabled && (
        <S.Button
          onClick={onClick}
        >
          {buttonText}
        </S.Button>
      )}
      {secondButton && <span>|</span>}
      {secondButton && (
        <S.Button onClick={secondOnClick} variants={'exportButton'}>{secondButtonText}</S.Button>
      )}
      {isOccurrence && (
        <S.StyledReactTooltip
          id="searchTooltip"
          place="right"
          type="dark"
          effect="solid"
          backgroundColor={"var(--black-400)"}
        />
      )}
    </S.SearchBar>
  );
}
